const transactionalMailDocumentationUrl = process.env.REACT_APP_NEUTRON_DOCUMENTATION_URL;

const apiDocumentationUrl = (isReseller) => (
  isReseller
    ? transactionalMailDocumentationUrl.replace('everlytic', 'senderguide')
    : transactionalMailDocumentationUrl
);

export default apiDocumentationUrl;
